import { makeStyles } from 'tss-react/mui';
import { Warning } from '@mui/icons-material';
import { IconWithText } from '@uplift/ui-v2';

export type RequiredTextProps = {
  children: string;
};

export const RequiredText: React.VFC<RequiredTextProps> = props => {
  const { classes } = useRequiredTextStyles();

  return (
    <IconWithText
      icon={<Warning className={classes.icon} />}
      className={classes.text}
    >
      {props.children}
    </IconWithText>
  );
};

const useRequiredTextStyles = makeStyles({ name: 'RequiredText' })(theme => ({
  icon: {
    color: theme.palette.warning.main,
  },
  text: {
    fontWeight: 700,
    display: 'flex',
  }
}));
